import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa"; // 아이콘 추가
import "./adminNavbar.css";

function AdminNavbar() {
  const [logoWidth, setLogoWidth] = useState("200px");
  const navigate = useNavigate();
  const [user, setUser] = useState(null); // 사용자 정보 상태

  // 뷰포트 크기에 따라 로고 크기 변경
  useEffect(() => {
    const updateLogoSize = () => {
      if (window.innerWidth <= 576) {
        setLogoWidth("150px");
      } else if (window.innerWidth <= 768) {
        setLogoWidth("170px");
      } else {
        setLogoWidth("200px");
      }
    };

    window.addEventListener("resize", updateLogoSize);
    updateLogoSize();
    return () => window.removeEventListener("resize", updateLogoSize);
  }, []);

  // 사용자 정보 세션에서 불러오기
  useEffect(() => {
    const storedUser = sessionStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogout = () => {
    // 로그아웃 처리
    sessionStorage.removeItem("user"); // 세션에서 사용자 정보 제거
    navigate("/login"); // 로그인 페이지로 이동
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="admin-navbar">
      <Container>
        <Navbar.Brand href="/admin">
          <img
            src="/images/logo/logo.png"
            alt="Admin Logo"
            style={{
              maxWidth: logoWidth,
              height: "auto",
            }}
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="admin-navbar-nav" />
        <Navbar.Collapse id="admin-navbar-nav">
          <Nav className="ms-auto">
            {user ? (
              <>
                <Nav.Link href="/my-page">
                  {user.nameKor}님{" "}
                  <FaUserCircle style={{ marginLeft: "5px" }} />
                </Nav.Link>
                <Nav.Link onClick={handleLogout}>로그아웃</Nav.Link>
                <Nav.Link href="/">사용자 페이지</Nav.Link>
              </>
            ) : (
              <Nav.Link href="/login">로그인</Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default AdminNavbar;
